import React from 'react'
import { faQuestionCircleRegular, faUsersRegular, FaIcon } from '@/lib/fa'
import Radio from '@/modules/drivers/shared/Radio'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import { useCertificateStore } from '@/modules/drivers/stores/certificateStore'
import { useSideSelectionStore } from '@/modules/drivers/stores/sideSelectionStore'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'

const CertificateCreateFor = () => {
  const { data, createForSelectedDrivers, setCreateForSelectedDrivers } =
    useCertificateStore()
  const { sideCheckedIds } = useSideSelectionStore()
  const { basicDrivers } = useDrivers()

  const currentDriverName = basicDrivers.find(
    (d) => String(d.id) === String(data?.driverId),
  )?.fullName


  const selectedDrivers = basicDrivers.filter((d) =>
    sideCheckedIds.includes(d.id),
  )
  const hasSelection = selectedDrivers.length > 0


  React.useEffect(() => {
    if (!hasSelection && createForSelectedDrivers) {
      setCreateForSelectedDrivers(false)
    }
  }, [hasSelection])

  return (
    <div className="tw-flex tw-gap-4">
      <div className="tw-w-full tw-max-w-[200px] tw-space-y-2">
        <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faUsersRegular} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            Utwórz dla
          </p>
        </div>
      </div>
      <div className="tw-w-full tw-space-y-2">
        <div className="tw-flex tw-items-center tw-gap-4">
          <div
            className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2"
            onClick={() => setCreateForSelectedDrivers(false)}
          >
            <Radio
              onClick={() => setCreateForSelectedDrivers(false)}
              checked={!createForSelectedDrivers}
            />
            <p className="tw-text-sm tw-text-content-base">
              {currentDriverName
                ? `Tego kierowcę (${currentDriverName})`
                : 'Tego kierowcę'}
            </p>
          </div>

          <div className="tw-flex tw-items-center tw-gap-2">
            <div
              className={`tw-flex tw-items-center tw-gap-2 ${hasSelection ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed tw-opacity-50'}`}
              onClick={() => hasSelection && setCreateForSelectedDrivers(true)}
              title={hasSelection ? undefined : 'Brak zaznaczonych kierowców'}
            >
              <Radio
                disabled={!hasSelection}
                onClick={() => hasSelection && setCreateForSelectedDrivers(true)}
                checked={createForSelectedDrivers}
              />
              <p className="tw-text-sm tw-text-content-base">
                Zaznaczeni kierowcy
                {hasSelection ? ` (${selectedDrivers.length})` : ''}
              </p>
            </div>

            {hasSelection && (
              <Tooltip
                text={selectedDrivers.map((d) => d.fullName).join(', ')}
                maxWidth="22rem"
             
                portal
                zIndex={10000}
              >
                <FaIcon
                  icon={faQuestionCircleRegular}
                  className="tw-h-3.5 tw-w-3.5 tw-text-content-subtle"
                />
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CertificateCreateFor
